import { useEffect } from "react";

// Sayfa bazlı SEO: başlık ve açıklama. SPA'da her sayfa kendi
// <title> ve meta description değerini yönetir; ayrılırken eski haline döner.
export default function usePageMeta(title: string, description?: string) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    if (description) {
      let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      const prevContent = meta?.getAttribute("content") ?? "";
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);

      return () => {
        document.title = prevTitle;
        meta?.setAttribute("content", prevContent);
      };
    }

    return () => {
      document.title = prevTitle;
    };
  }, [title, description]);
}